import React from 'react';
import axios from 'axios';
import qs from 'qs';
import {  isPc, DHB_API_PC, omitEmptyValue } from './utils';

const instance = axios.create({
  // timeout: 30000,
  baseURL: /* '/', */ DHB_API_PC,
  withCredentials: true,
  // withCredentials: true,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },

  // transformRequest: [
  //   function (data, headers) {
  //     const search = new URLSearchParams(window.location.search);
  //     data['val'] = JSON.stringify({
  //       ...data['val'],
  //       // skey: search.get('skey') || getQueryString('skey'),
  //       skey: search.get('skey'),
  //       version: '9.2',
  //     });
  //     return qs.stringify(data);
  //   },
  // ],
});


instance.interceptors.request.use(
  async (config) => {
    config.data = config.data || {};
    config.baseURL = DHB_API_PC;
    if(config.params){
      config.params = omitEmptyValue(config.params)  
      // Object.keys(config.params).forEach(key=>{
      //   if(config.params[key]===undefined){
      //       delete config.params[key]
      //   } 
      // })
    }
    return config;
  },
  (error) => {
    return Promise.reject(new Error(error));
  },
);

instance.interceptors.response.use(
  (res) => {
    // Toast.hide();
    // message.destroy()
    // try {
    //   if (res.data.message && res.data.code != 100 && res.data.code != 200) {
    //     Toast.info(res.data.message);
    //   }
    // } catch (e) {}
    return res.data;
  },
  (error) => {
    // message.destroy()
    // Toast.hide();
    // const { response = {}, config } = error;
    // const { data, status } = response;
    // console.log(data, response, error, 'data');
    // if (data.error.message === 'Network Error') {
    //   return Promise.reject(data.error.message);
    // } else {
    //   return Promise.reject(new Error(response));
    // }
  },
);

// export default instance;
/** @deprecated 请用httpPc */
export const axiosHttp = instance;
